import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from './router'

Vue.use(VueAnalytics, {
	id: 'UA-20663210-1',
	router
})

export default {}



// WEBPACK FOOTER //
// ./src/initializers/vue-analytics.js